var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureBath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    transform: "translate(261 -983)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-237.5,994H-259v-8c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v0.5c0,0.3,0.2,0.5,0.5,0.5 s0.5-0.2,0.5-0.5V986c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3v8h-0.5c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h0.5v3.5 c0,2.9,2,5.5,4.8,6.3l-0.8,1.5c-0.1,0.2,0,0.5,0.2,0.7c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.4-0.3l0.9-1.8c0.2,0,0.4,0,0.7,0h9 c0.2,0,0.4,0,0.7,0l0.9,1.8c0.1,0.2,0.3,0.3,0.4,0.3c0.1,0,0.2,0,0.2,0c0.2-0.1,0.3-0.4,0.2-0.7l-0.8-1.5c2.8-0.8,4.8-3.3,4.8-6.3 V995h0.5c0.3,0,0.5-0.2,0.5-0.5S-237.2,994-237.5,994z M-239,998.5c0,3-2.5,5.5-5.5,5.5h-9c-3,0-5.5-2.5-5.5-5.5V995h20V998.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-239,995v3.5c0,3-2.5,5.5-5.5,5.5h-9c-3,0-5.5-2.5-5.5-5.5V995H-239z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-255,989.5v1c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-1c0-0.3,0.2-0.5,0.5-0.5 S-255,989.2-255,989.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-253,991.5v1c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-1c0-0.3,0.2-0.5,0.5-0.5 S-253,991.2-253,991.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-253,988.5v1c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-1c0-0.3,0.2-0.5,0.5-0.5 S-253,988.2-253,988.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureBath);
export default __webpack_public_path__ + "static/media/feature-bath.1561b7c352241378df55e05d571ff87d.svg";
export { ForwardRef as ReactComponent };